export var CaptchaServiceType;
(function (CaptchaServiceType) {
    CaptchaServiceType["NET_EASY"] = "net_easy";
    CaptchaServiceType["BOTION"] = "botion";
})(CaptchaServiceType || (CaptchaServiceType = {}));
//# sourceMappingURL=CaptchaServiceType.js.map